var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "report-slider" },
    [
      _c("div", { staticClass: "requirements-nav" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "button-container" },
        [
          _c("DirectionButton", {
            staticClass:
              "report-slider__pagination--prev report-slider__pagination-top--prev swiper-button-prev",
            attrs: {
              "props-handle-click": _vm.prev,
              direction: "prev",
              icon: "arrow-left--white",
            },
          }),
          _vm._v(" "),
          _c("DirectionButton", {
            staticClass:
              "report-slider__pagination--next report-slider__pagination-top--next swiper-button-next",
            attrs: {
              "props-handle-click": _vm.next,
              direction: "next",
              icon: "arrow-right--white",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "swiper",
        { ref: "reportSlider", attrs: { options: _vm.optionsPaginationTop } },
        _vm._l(_vm.productsAndServicesData, function (item, index) {
          return _c("swiper-slide", { key: index }, [
            _c(
              "div",
              { staticClass: "requirements-row" },
              [
                _c("h2", { staticClass: "licence-title" }, [
                  _vm._v(_vm._s(item.licenseName)),
                ]),
                _vm._v(" "),
                _c("RequirementsReportList", {
                  attrs: {
                    jurisdiction: item.jid,
                    requirements: item.categories,
                    reports: true,
                    full: false,
                  },
                }),
              ],
              1
            ),
          ])
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }